<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!--ion-title> Verschieben </ion-title-->

    <ion-buttons slot="end">
      <ion-button
        [disabled]="
          selectedFolder == null ||
          selectedFolder?.id == itemsToMove[0].parentId ||
          selectedFolder?.id == null
        "
        (click)="confirm()"
      >
        <!--ion-icon name="add" size="large" slot="icon-only"></ion-icon-->
        Hierher verschieben
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <lib-file-tree
    [isMoveTree]="true"
    (currentFolderNodeItemChanged)="currentFolderNodeItemChanged($event)"
    [itemsToMove]="itemsToMove"
    [conSitesMode]="conSitesMode"
  ></lib-file-tree>
</ion-content>
